import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { DpaDocument } from '../components/legal/DpaDocument';
import { SecurityMeasuresDocument } from '../components/legal/SecurityMeasuresDocument';

type LegalTab = 'dpa' | 'measures';

export const LegalDocumentsPage = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab: LegalTab = searchParams.get('tab') === 'measures' ? 'measures' : 'dpa';

  const handleTabChange = (tab: LegalTab) => {
    const nextParams = new URLSearchParams(searchParams);
    nextParams.set('tab', tab);
    setSearchParams(nextParams, { replace: true });
  };

  const tabClassName = (tab: LegalTab) =>
    `px-4 py-2 text-sm font-medium border-b-2 transition ${
      activeTab === tab
        ? 'border-primary text-primary'
        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
    }`;

  return (
    <div className="h-screen overflow-y-auto p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-display text-primary mb-6">
          {t('legal.documents_page.title')}
        </h1>

        <div className="flex gap-2 border-b border-gray-200 mb-8">
          <button onClick={() => handleTabChange('dpa')} className={tabClassName('dpa')}>
            {t('legal.documents_page.tabs.dpa')}
          </button>
          <button onClick={() => handleTabChange('measures')} className={tabClassName('measures')}>
            {t('legal.documents_page.tabs.measures')}
          </button>
        </div>

        {activeTab === 'dpa' ? <DpaDocument /> : <SecurityMeasuresDocument />}
      </div>
    </div>
  );
};
